import { ReactElement } from 'react'
import { MatchcardScreenProps } from './MatchcardScreen'
import styles from './MobileMatchcardScreen.module.scss'
import { MobileBodyLarge, MobileHeadlineLarge, MobileTitleMedium } from '../../Typography'
import { mapTitleToChampionshipString, Title } from '../../components/wrestler/Title'

export const MobileMatchcardScreen = ({
  matches,
  announcements,
  eventData,
  onBackClick,
}: MatchcardScreenProps): ReactElement => {
  const announcementsHeader = matches.length === 0 ? 'Ankündigungen' : 'Weitere Ankündigungen'

  return (
    <div className={styles.container}>
      <div className={styles.wideColumn}>
        <div className={styles.column}>
          <MobileBodyLarge className={styles.pointer} onClick={onBackClick}>
            Zurück zum Startbildschirm
          </MobileBodyLarge>
          <MobileHeadlineLarge>{eventData.eventName}</MobileHeadlineLarge>
        </div>
        <div className={styles.column}>
          <div className={styles.imageContainer}>
            <img
              className={styles.backgroundImage}
              src={eventData.eventHintergrund}
              alt={'Bannerhintergrund zur nächsten Show'}
            />
            <img
              className={styles.logoImage}
              src={eventData.eventLogo}
              alt={'Eventlogo zur nächsten Show'}
            />
          </div>
          <div className={styles.matchcardImageRow}>
            {matches.length > 0 &&
              matches
                .filter((matchcardData) => matchcardData.bildAnkuendigung)
                .map((matchcardData) => (
                  <img
                    key={matchcardData.id}
                    src={matchcardData.bildAnkuendigung}
                    alt={`Matchcard für ${matchcardData.teilnehmer}`}
                  />
                ))}
            {announcements.length > 0 &&
              announcements
                .filter((matchcardData) => matchcardData.bildAnkuendigung)
                .map((matchcardData) => (
                  <img
                    key={matchcardData.id}
                    src={matchcardData.bildAnkuendigung}
                    alt={`Ankündigung für ${matchcardData.wrestlerName}`}
                  />
                ))}
          </div>
        </div>
      </div>
      <div className={styles.wideColumn}>
        <MobileHeadlineLarge>Event Infos</MobileHeadlineLarge>
        <div className={styles.column}>
          <MobileBodyLarge>{eventData.eventHalle}</MobileBodyLarge>
          {eventData.isOpenSunday && (
            <MobileBodyLarge>
              Eintritt für (Premium-)Supporter und Kinder unter 16 Jahren frei
            </MobileBodyLarge>
          )}
          {eventData.isOpenSunday && <MobileBodyLarge>Tickets für 5€ am Einlass</MobileBodyLarge>}
          <MobileBodyLarge>
            Einlass: {eventData.eventEinlass} | Beginn: {eventData.eventBeginn}
          </MobileBodyLarge>
        </div>
        <div className={styles.column}>
          {matches.length > 0 && (
            <>
              <MobileTitleMedium>Matches</MobileTitleMedium>
              {matches.map((matchcardData) => (
                <div key={matchcardData.id} className={styles.tightColumn}>
                  <MobileBodyLarge>{matchcardData.stipulation}</MobileBodyLarge>
                  {matchcardData.title !== undefined &&
                    matchcardData.title.filter((title) => title !== Title.NONE).length > 0 && (
                      <MobileBodyLarge fontWeight={600}>
                        {matchcardData.title.map(mapTitleToChampionshipString).join(' & ')}
                      </MobileBodyLarge>
                    )}
                  <MobileBodyLarge>{matchcardData.teilnehmer}</MobileBodyLarge>
                </div>
              ))}
            </>
          )}
          {announcements.length > 0 && (
            <>
              <MobileTitleMedium>{announcementsHeader}</MobileTitleMedium>
              {announcements.map((matchcardData) => (
                <div key={matchcardData.id}>
                  <MobileBodyLarge>{matchcardData.wrestlerName}</MobileBodyLarge>
                </div>
              ))}
            </>
          )}
          {matches.length === 0 && announcements.length === 0 && (
            <MobileBodyLarge>
              Ankündigungen zu{' '}
              {!eventData.eventName || eventData.eventName === ''
                ? 'diesem Event'
                : eventData.eventName}{' '}
              folgen in Kürze…
            </MobileBodyLarge>
          )}
        </div>
      </div>
    </div>
  )
}
